import * as angular from 'angular';
import { ComponentDefinition } from '../../models';
import { IrangeCheckHelper } from '../../services';

class InputWithRangeController implements angular.IComponentController {
    isOutOfRange: boolean;
    model: number;
    outOfRangeMessage: string;

    readonly isDisabled: boolean;
    readonly max?: number;
    readonly min?: number;
    readonly onChange: ({ value: number }) => any;

    static $inject = ['$scope', 'rangeCheckHelper'];

    constructor(
        private _$scope: angular.IScope,
        private _rangeCheckHelper: IrangeCheckHelper
    ) {
    }

    $onInit() {
        this.updateTranslation();
        this._$scope.$watch(() => this.model, () => this.updateOutOfRange());
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['min'] || changesObj['max']) {
            this.updateTranslation();
            this.updateOutOfRange();
        }
    }

    updateOutOfRange() {
        this.isOutOfRange = this._rangeCheckHelper.isOutOfRange(this.model, this.min, this.max);
    }

    updateTranslation() {
        this.outOfRangeMessage = this._rangeCheckHelper.updateTranslation(this.min, this.max);
    }

    change() {
        if (this.onChange) {
            this.onChange({ value: this.model });
        }
    }
}

export const wtInputWithRange: ComponentDefinition = {
    componentId: 'wtInputWithRange',
    controller: InputWithRangeController,
    template: require('./inputWithRange.component.html'),
    controllerAs: 'vm',
    bindings: {
        decimals: '<?',
        hasFocus: '=?',
        isDisabled: '<?',
        max: '<?',
        min: '<?',
        model: '=',
        name: '@',
        onChange: '&?',
        required: '@',
    }
};